import { styled } from 'stitches.config'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import { Hr } from 'components/Hr'

export const ProductPageRoot = styled('div', {
  backgroundColor: '$secondary-100',
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
})

export const Wrapper = styled('span', {
  padding: '$15 $3 $10',

  '@bp2': {
    padding: '$15',
    paddingTop: 0,
  },

  '@bp4': {
    width: '$max',
  },
})

export const BackButton = styled('span', {
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  color: '$primary-800',
  padding: ' $1 0',

  '@bp2': {
    top: 'calc($2 + $1 / 2)',
    transform: 'translateX(-$space$8)',
  },
})

export const Summary = styled('div', {
  display: 'flex',
  textAlign: 'center',
  backgroundColor: '$accent-menu-bo',
  padding: '$3',
  border: '1px solid $secondary-600',
  borderRadius: '$4',

  '@bp2': {
    padding: '$5',
  },
})

export const RecipesSection = styled('div', {
  width: '100%',
  display: 'flex',
  gap: '$2',
  flexDirection: 'column',
})

export const RecipesWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '$3',

  '@bp2': {
    flexDirection: 'row',
    gap: '$5',

    '& > div': {
      flex: 1,
    },
  },
})

export const StampWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '$1',

  '&::before': {
    width: '1px',
    height: '33px',
    content: ' ',
    backgroundColor: '$secondary-600',
  },

  '& img': {
    size: '$10',
  },
})

export const StyledHr = styled(Hr, {
  display: 'none',

  '@bp2': {
    display: 'block',
  },
})

export const StickyPrice = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',

  position: 'fixed',
  zIndex: '$1',
  bottom: '0',
  left: '50%',
  transform: 'translate(-50%)',

  backgroundColor: '$accent-menu-bo',
  padding: '$5 $3',
  borderRadius: '$4 $4 0 0',
  border: '1px solid $secondary-600',

  '@bp2': {
    width: '100',
    position: 'relative',
    bottom: 'auto',
    left: 'auto',
    transform: 'none',
    borderRadius: '$4',

    '& button': {
      alignSelf: 'center',
      width: '310px',
    },
  },
})

export const StickyPriceTitle = styled('div', {
  display: 'none',

  '@bp2': {
    display: 'flex',
    justifyContent: 'center',
  },
})
